import { render, staticRenderFns } from "./PriceBoard.vue?vue&type=template&id=7c113813&scoped=true&lang=pug"
import script from "./PriceBoard.vue?vue&type=script&lang=js"
export * from "./PriceBoard.vue?vue&type=script&lang=js"
import style0 from "./PriceBoard.vue?vue&type=style&index=0&id=7c113813&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c113813",
  null
  
)

export default component.exports